module.exports = __webpack_public_path__ + "static/media/ic_photo_empty.71283ddc.svg";